import React from 'react'
import Observer from 'react-intersection-observer'
import styles from './LiveShowPlaylist.module.css'
import { Spinner } from '../../components'
import LiveShowCollection from '../LiveShowCollection/LiveShowCollection'
import noLiveStreamingIcn from '../../assets/ic-nolivestreaming.svg'

const NewPlaylistViewContent = ({
  data,
  searchView,
  completed,
  fetchNextData,
  handleSelectChannel,
  maxItemsPerRow }) => {
  
  const generateDataItems = () => {
    const results = []

    data.forEach((item, key) => {
      item.type = "stream"
      results.push(
        <LiveShowCollection
          onChannelClick={handleSelectChannel}
          index={item.id}
          key={key}
          data={item}
        />
      )
    })

    for (let i = 1; i <= maxItemsPerRow - (data.length % maxItemsPerRow); i++) {
      results.push(<LiveShowCollection empty={true} key={`empty_${i}`} />)
    }

    return results
  }

  return (
    <>
      <div className={styles['collection']}>
        <div className={styles['list-container']}>
          {generateDataItems()}
        </div>
        {!searchView && completed && !data.length && (
          <div className={styles['no-data']}>
            <img width={140} height={140} src={noLiveStreamingIcn} alt="streaming icon" />
            <div className={styles['message']}>No live session available</div>
          </div>

        )}
        {!searchView && !completed && (
          <div className={styles['loader-wrapper']}>
            <Observer
              onChange={inView => {
                inView && data.length && fetchNextData()
              }}
            >
              <Spinner />
            </Observer>
          </div>
        )}
      </div>
    </>
  )
}

export default NewPlaylistViewContent